
export class SearchFilter {
  //primary search terms (changes here should restart the search completely)
  query: string = ""

  //secondary search terms/facets (changes here should restart pagination)
  platformTypes: string[] = [];
  categories: string[] = [];
  showHidden: boolean = false;
  locations: string[] = ["ALL"];

  //pagination - this is the current page (changes here should be ignored)
  searchAfter: string | string[] = '';

  fields: string[] = []; //specify the fields to return. if null or empty list, return all.

  sortBy: string = ''; //or '', 'location'
  sortByOpts: SearchFilterSortByOpts = new SearchFilterSortByOpts();
}

export class SearchFilterSortByOpts {
  locationZipcodes?: string[]; //used when sortBy is 'location'
}
